<template>
    <div>
        <table class="table table-striped table-sm full-width">
            <tr v-for="note in notes" :key="note.id">
                <td>
                    <small>{{note.userName }} - <span class="noteDate" onclick="return false;" :title="moment.utc(note.created_at).tz(timezone).format('MMMM Do YYYY, h:mm:ss a')">{{ moment.utc(note.created_at).tz(timezone).format('YYYY-MM-DD - hh:mm a')}}</span></small><br/>
                    <span class="font-size-sm" v-html="note.note"></span>
                </td>
            </tr>
        </table>
        
        <textarea id="note" class="form-control" v-model="note"></textarea><br/>
        <button class="btn btn-square btn-outline-primary" @click.prevent="saveNote()"><i class="fa fa-fw fa-plus mr-1"></i> Add Note</button><br/><br/>
    </div>
</template>

<script>
export default {
    props: {
        notes: Array,
        orderId: Number,
        partnerId: Number,
        timezone: String,
    },
    data:() => {
        return {
            note:'',
        }
    },
    methods: {
        saveNote: function() {

            axios.post(`/notes`, {orderId:this.orderId, note:this.note, admin_partner_id:this.partnerId}).then(response => {
                this.success_msg = 'Note updated successfully.';
                this.note = '';
                this.notes.push(response.data.note);
            }).catch(error => {
                this.error_msg = error.response.data.message;
            });

        },
    }
}
</script>